import * as React from "react";
import { forwardRef } from "react";
const SvgHamburger = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "currentColor",
	height: "1em",
	viewBox: "0 0 24 24",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	fill: "none"
}), /* @__PURE__ */ React.createElement("path", { d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" }));
const ForwardRef = forwardRef(SvgHamburger);
export default ForwardRef;
